import React, { useState, useEffect } from 'react'
import {
  Typography, 
  Menu,
  MenuItem,
  Badge,
  Box,
  Divider,
  Chip
} from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';
import IconButton from '@mui/material/IconButton';
import { deleteNotificationById, getNotificationList } from 'services/notifications';
import { Stack } from '@mui/system';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { useSnackbar } from 'notistack';

const Notifications = () => {

  const allFilterTagName = 'All';
  const [notificationEl, setNotificationEl] = useState(null);
  const [notifications, setNotifications] = useState([]);
  const [filterChips, setFilterChips] = useState([]);
  const [selectedFilterChip, setSelectedFilterChip] = useState(allFilterTagName);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    getNotifications();
  }, []);

  const showNotifications = (event) => {
    const target = event.currentTarget;
    setNotificationEl(target)
  }

  const closeNotifications = () => {
    setNotificationEl(null);
  }

  function getNotifications() {
    getNotificationList().then(({response}) => {
      if(Array.isArray(response)){
        updateFilterChips(response);
        setNotifications([...( response || [])]);
      }else{
        setNotifications([]);
      }
    });
  }

  function updateFilterChips(data = []) {
    const allFilters = data.map(a=>a.tag);
    const uniqueFilterTags = [...new Set(allFilters)];
    setFilterChips([allFilterTagName, ...uniqueFilterTags]);
  }

  const onFilterChipClick = (tag) => () => {
    setSelectedFilterChip(tag);
  };
  
  const deleteNotification = (notificationId) => () => {
    deleteNotificationById(null, null, notificationId).then(({response, error}) => {
      if(error){
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      }else{
        getNotifications();
      }
    });
  };

  return notifications.length > 0 ? (
    <>
      <IconButton
        size="large"
        aria-label="notifications"
        aria-controls="notification-appbar"
        aria-haspopup="true"
        onClick={showNotifications}
        color="inherit"
      >
        <Badge color="error">
          <NotificationsIcon />
        </Badge>
      </IconButton>
      <Menu
        id="notification-appbar"
        anchorEl={notificationEl}  
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            boxShadow: '0px 2px 8px rgba(0,0,0,0.32)',
            // filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))', // commented due to flickering
            mt: 0,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            '&:before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 20,
              width: 10,
              height: 10,
              bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
            '.notification:hover .notificationDeleteIcon': {
              display: 'block'
            }
          },
        }}
        open={Boolean(notificationEl)}
        onClose={closeNotifications}
      >
        <Box sx={{ 
            overflowY: 'auto',
            maxHeight: '50vh',
          }}>
          <Box sx={{p: 1.3}} overflow="auto">
            <Stack direction="row" spacing={1.2} justifyContent="flex-start">
              {filterChips.map((tag, i) => (
                <Chip 
                  key={i} 
                  label={tag} 
                  color={(selectedFilterChip === tag) ? 'primary': 'default'} 
                   onClick={onFilterChipClick(tag)}
                />
              ))}
            </Stack>
          </Box>
          {notifications.filter(notification=>(notification.tag === selectedFilterChip || selectedFilterChip === allFilterTagName)).map(({title, body, createdOn, id}, i) => (
            <MenuItem onClick={closeNotifications} key={i} sx={{display: 'block'}}>
              <Stack className='notification'>
                <Divider sx={{mb: .6, mt: .2}}/>
                <HighlightOffIcon onClick={deleteNotification(id)} color="error" className='notificationDeleteIcon' sx={{position: 'absolute', right: '1rem', top: '.8rem', display:{sx:'block', sm: 'none'} }}/>
                <Typography variant="subtitle2" display="block" sx={{maxWidth: '480px', width:'100%', wordWrap: 'wordWrap', whiteSpace: 'normal'}}>
                  {title}
                </Typography>
                <Typography variant="body2" color="typography" display="block"sx={{maxWidth: '480px', width:'100%', wordWrap: 'wordWrap', whiteSpace: 'normal', fontSize: '.77rem'}}>
                  {body}
                </Typography>
                <Typography color="typography.light" textAlign="right" variant="caption" display="block" sx={{maxWidth: '480px', width:'100%', wordWrap: 'wordWrap', whiteSpace: 'normal'}}>
                  {createdOn}
                </Typography>
              </Stack>
            </MenuItem>
          ))}
        </Box>
      </Menu>
    </>
  ) : null;
}
 
export default React.memo(Notifications);
